import { useState } from 'react';
import CandidateCard from './CandidateCard.jsx';
import ProgressIndicator from './ProgressIndicator.jsx';
import { SELECTION_STATE } from './utils/constants.js';
import './MatchView.css';

/**
 * MatchView - Display current match with two candidates
 * @param {Object} props
 * @param {Object} props.currentRound - Current round object with matches
 * @param {number} props.currentMatchIndex - Index of current match in round
 * @param {Function} props.onSelectWinner - Callback when winner is selected
 * @param {string} props.language - Language code ('ko' or 'en')
 */
export default function MatchView({
  currentRound,
  currentMatchIndex,
  onSelectWinner,
  language = 'ko',
}) {
  const [selectionState, setSelectionState] = useState({
    candidate1: SELECTION_STATE.IDLE,
    candidate2: SELECTION_STATE.IDLE,
  });
  const [isTransitioning, setIsTransitioning] = useState(false);

  const currentMatch = currentRound.matches[currentMatchIndex];
  const { candidate1, candidate2 } = currentMatch;

  const handleSelectCandidate = (selectedCandidate) => {
    // Determine winner and loser
    const isCandidate1Winner = selectedCandidate.id === candidate1.id;

    setSelectionState({
      candidate1: isCandidate1Winner
        ? SELECTION_STATE.WINNER
        : SELECTION_STATE.LOSER,
      candidate2: isCandidate1Winner
        ? SELECTION_STATE.LOSER
        : SELECTION_STATE.WINNER,
    });

    // Wait for loser to fade out (600ms) and show winner (200ms)
    setTimeout(() => {
      // Start transition fade out
      setIsTransitioning(true);

      // After transition fade out (500ms), notify parent
      setTimeout(() => {
        onSelectWinner(selectedCandidate);
      }, 500);
    }, 800);
  };

  const isSelectionMade =
    selectionState.candidate1 !== SELECTION_STATE.IDLE ||
    selectionState.candidate2 !== SELECTION_STATE.IDLE;

  return (
    <div className={`match-view ${isTransitioning ? 'match-view--transitioning' : ''}`}>
      <ProgressIndicator
        roundName={currentRound.roundName}
        currentMatchIndex={currentMatchIndex}
        totalMatches={currentRound.matches.length}
        language={language}
      />

      <div className="match-view__arena">
        <div className="match-view__candidate">
          <CandidateCard
            candidate={candidate1}
            onClick={handleSelectCandidate}
            selectionState={selectionState.candidate1}
            disabled={isSelectionMade}
            language={language}
          />
        </div>

        <div className="match-view__vs">VS</div>

        <div className="match-view__candidate">
          <CandidateCard
            candidate={candidate2}
            onClick={handleSelectCandidate}
            selectionState={selectionState.candidate2}
            disabled={isSelectionMade}
            language={language}
          />
        </div>
      </div>
    </div>
  );
}
